export const COURIER_MAPPING_TOGGLE_ERROR= "COURIER_MAPPING_TOGGLE_ERROR";
export const COURIER_MAPPING_TOGGLE_SUCCESS= "COURIER_MAPPING_TOGGLE_SUCCESS";
export const COURIER_MAPPING_TOGGLE_REQUEST= "COURIER_MAPPING_TOGGLE_REQUEST";
